import { WORKFLOW_LIMITS } from "@sagot/constants";
import { useTranslation } from "@sagot/i18n";
import { Icon } from "@sagot/ui";
import type { EmailVisitorStep } from "../types";
import { CountedInput, CountedTextarea } from "./counted-field";
import { VariableList, type FormProps } from "./webhook-form";

const F = "engage.workflows.fields";

/** Email the visitor: a subject and a Markdown body with variables; sent only with a known address and consent. */
export function EmailVisitorForm({ step, disabled, onChange }: FormProps<EmailVisitorStep>) {
  const { t } = useTranslation();
  return (
    <div className="space-y-4">
      <p className="flex items-start gap-2 rounded-md bg-info-soft p-3 text-xs text-fg-muted" data-testid="email-consent">
        <Icon name="info" className="mt-0.5 size-3.5 shrink-0" />
        {t(`${F}.emailConsent`)}
      </p>
      <CountedInput label={t(`${F}.emailSubject`)} value={step.subject} max={WORKFLOW_LIMITS.emailSubject} disabled={disabled} onChange={(subject) => { onChange({ ...step, subject }); }} />
      <div>
        <CountedTextarea label={t(`${F}.emailBody`)} hint={t(`${F}.emailBodyHint`)} rows={8} value={step.body} max={WORKFLOW_LIMITS.emailBody} disabled={disabled} onChange={(body) => { onChange({ ...step, body }); }} />
        <VariableList />
      </div>
    </div>
  );
}
